const dataLayer = typeof window !== 'undefined'
    ? window.dataLayer
    : [];

export {
    dataLayer,
};
